/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface BookClassRoomRequest
 */
export interface BookClassRoomRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof BookClassRoomRequest
     */
    classRoomId: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the BookClassRoomRequest interface.
 */
export function instanceOfBookClassRoomRequest(value: object): value is BookClassRoomRequest {
    if (!('classRoomId' in value) || value['classRoomId'] === undefined) return false;
    return true;
}

export function BookClassRoomRequestFromJSON(json: any): BookClassRoomRequest {
    return BookClassRoomRequestFromJSONTyped(json, false);
}

export function BookClassRoomRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookClassRoomRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'classRoomId': ApiUserTasksGetPageParameterFromJSON(json['classRoomId']),
    };
}

export function BookClassRoomRequestToJSON(json: any): BookClassRoomRequest {
    return BookClassRoomRequestToJSONTyped(json, false);
}

export function BookClassRoomRequestToJSONTyped(value?: BookClassRoomRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classRoomId': ApiUserTasksGetPageParameterToJSON(value['classRoomId']),
    };
}

